import PropTypes from 'prop-types'

import FormContactSellerExperiment from './components/FormContactSellerExperiment/index.js'
import {FIELDS, FormContactSellerProvider} from './useContactSellerState/index.js'

const FormContactSellerWrapper = props => {
  return (
    <FormContactSellerProvider {...props}>
      <FormContactSellerExperiment />
    </FormContactSellerProvider>
  )
}

FormContactSellerWrapper.displayName = 'FormContactSeller'

FormContactSellerWrapper.propTypes = {
  hasFinancingData: PropTypes.bool,
  pageName: PropTypes.string,
  subscriptionPriceOptionSelected: PropTypes.shape({
    totalMonths: PropTypes.number,
    monthlyPrice: PropTypes.number,
    kmIncluded: PropTypes.number,
    kmIncludedPeriod: PropTypes.string,
    targetBuyer: PropTypes.string
  })
}

export default FormContactSellerWrapper
export {FIELDS as formContactSellerFields}
export {
  default as FormContactSellerV2,
  StickyContactBar,
  useAvailableActions,
  FORM_PRESENTATIONS,
  defaultAvailableActions,
  CONTACT_ACTION_IDS,
  availableActionsPropType,
  buyerIntentionsSelectionPropType
} from './v2/index.js'
